export const dlClassNames = "text-ui p-2 [&_dt]:font-semibold [&_dd]:mb-5";
